/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class UserNotificationAPI {

  /**
   * Method that returns user's notification settings
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiUserNotificationSettings(): CancelablePromise<{
    campaign_life: {
      campaign_is_update: {
        push: boolean;
        email: boolean;
      };
      campaign_global_status_change: {
        push: boolean;
        email: boolean;
      };
      campaign_pause_change: {
        push: boolean;
        email: boolean;
      };
      campaign_report_ready: {
        push: boolean;
        email: boolean;
      };
      media_approbation: {
        push: boolean;
        email: boolean;
      };
      media_rejection: {
        push: boolean;
        email: boolean;
      };
    };
    campaign_performance: {
      campaign_impression_half: {
        push: boolean;
        email: boolean;
      };
      campaign_impression_missing: {
        push: boolean;
        email: boolean;
      };
      campaign_impression_start: {
        push: boolean;
        email: boolean;
      };
    };
    budget: {
      campaign_budget_add: {
        push: boolean;
        email: boolean;
      };
      campaign_budget_empty: {
        push: boolean;
        email: boolean;
      };
      campaign_budget_half: {
        push: boolean;
        email: boolean;
      };
    };
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/user-notification/settings',
    });
  }

  /**
   * Method that returns filtered user's notifications
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static putApiUserNotificationSettings(
    requestBody: {
      campaign_life: {
        campaign_is_update: {
          push: boolean;
          email: boolean;
        };
        campaign_global_status_change: {
          push: boolean;
          email: boolean;
        };
        campaign_pause_change: {
          push: boolean;
          email: boolean;
        };
        campaign_report_ready: {
          push: boolean;
          email: boolean;
        };
        media_approbation: {
          push: boolean;
          email: boolean;
        };
        media_rejection: {
          push: boolean;
          email: boolean;
        };
      };
      campaign_performance: {
        campaign_impression_half: {
          push: boolean;
          email: boolean;
        };
        campaign_impression_missing: {
          push: boolean;
          email: boolean;
        };
        campaign_impression_start: {
          push: boolean;
          email: boolean;
        };
      };
      budget: {
        campaign_budget_add: {
          push: boolean;
          email: boolean;
        };
        campaign_budget_empty: {
          push: boolean;
          email: boolean;
        };
        campaign_budget_half: {
          push: boolean;
          email: boolean;
        };
      };
    },
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/user-notification/settings',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that returns user's notifications
   * @param types
   * @param categories
   * @param priorities
   * @param offset
   * @param limit
   * @param orderby
   * @param comparator
   * @param campaignId
   * @param after
   * @param read
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiUserNotification(
    types: Array<'campaign_global_status_change' | 'campaign_is_update' | 'campaign_pause_change' | 'campaign_impression_start' | 'campaign_impression_half' | 'campaign_impression_missing' | 'campaign_report_ready' | 'campaign_budget_half' | 'campaign_budget_add' | 'campaign_budget_empty' | 'media_approbation' | 'media_rejection'>,
    categories: Array<'campaign_life' | 'campaign_performance' | 'budget'>,
    priorities: Array<'low' | 'medium' | 'high'>,
    offset?: number,
    limit?: number,
    orderby?: Array<string>,
    comparator?: Array<string>,
    campaignId?: number | null,
    after?: string,
    read: boolean = false,
  ): CancelablePromise<Array<{
    id?: number;
    user_id: number;
    priority: 'low' | 'medium' | 'high';
    type: 'campaign_global_status_change' | 'campaign_is_update' | 'campaign_pause_change' | 'campaign_impression_start' | 'campaign_impression_half' | 'campaign_impression_missing' | 'campaign_report_ready' | 'campaign_budget_half' | 'campaign_budget_add' | 'campaign_budget_empty' | 'media_approbation' | 'media_rejection';
    category: 'campaign_life' | 'campaign_performance' | 'budget';
    read?: boolean;
    campaign_id?: number | null;
    media_id?: number | null;
    data?: string | null;
    created_at?: string;
    updated_at?: string;
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/user-notification',
      query: {
        'offset': offset,
        'limit': limit,
        'orderby': orderby,
        'comparator': comparator,
        'campaign_id': campaignId,
        'after': after,
        'types': types,
        'categories': categories,
        'priorities': priorities,
        'read': read,
      },
    });
  }

  /**
   * Method that delete user's notifications for given ids
   * @param ids
   * @returns any Default Response
   * @throws ApiError
   */
  public static deleteApiUserNotification(
    ids: Array<number>,
  ): CancelablePromise<{
    count: number;
  }> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/user-notification',
      query: {
        'ids': ids,
      },
    });
  }

  /**
   * Method that flags notifications as read
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static putApiUserNotificationRead(
    requestBody: {
      ids: Array<number>;
    },
  ): CancelablePromise<{
    count: number;
  }> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/user-notification/read',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

}
